var _rect, _g, _rect2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBothLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9460_850",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9460_850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#CF2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9198 10.5687L9 10.5632C7.38612 10.5632 6.04592 11.8606 6 13.5277C6 13.5742 6.03429 13.6085 6.0802 13.6085L12 13.614C13.6139 13.614 14.9541 12.3167 15 10.6551C14.9994 10.6036 14.9651 10.5687 14.9198 10.5687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 6.00551L9.00023 6C7.38574 6 6.04554 7.29673 6.00023 8.96449C6.00023 9.01102 6.03452 9.04591 6.07982 9.04591L14.9996 9.05142C16.6135 9.05142 17.9537 7.75408 17.9996 6.09245C18.0051 6.04041 17.9653 6.00551 17.92 6.00551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92644 15.2253C7.69175 14.9033 8.56909 15.2725 8.88624 16.0494C9.20338 16.8263 8.83971 17.7172 8.0744 18.0392C7.3091 18.3612 6.43175 17.9921 6.11461 17.2151C5.79747 16.4382 6.16114 15.5474 6.92644 15.2253Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9460_850",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 12,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 12,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9460_850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#005BAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0772 5L10.5048 12.4284L13.1144 9.1356L8.0772 5ZM15.024 13.1592L13.2488 9.3372L10.698 12.5964L15.024 13.1592ZM10.6644 12.8064L10.2024 16.2168L14.9092 13.3832L10.6644 12.8064ZM6.9292 19L9.676 18.272L10.3788 13.1592L6.9292 19ZM14.1616 10.782L15.1976 12.9884L16.3568 9.6704L14.1616 10.782ZM16.5444 9.7572L16.032 11.2552L17.068 12.1932L16.5444 9.7572Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBothLogo);
export default __webpack_public_path__ + "static/media/both-logo.6ae15f3de9ac3906f1d84be57b0ef6eb.svg";
export { ForwardRef as ReactComponent };